/** Start optional integrations after the document and its initial resources load. */
export function afterInitialLoad(callback: () => void): () => void {
  let timer: ReturnType<typeof setTimeout> | undefined
  const schedule = () => {
    timer = setTimeout(callback, 2000)
  }
  if (document.readyState === 'complete') schedule()
  else window.addEventListener('load', schedule, { once: true })

  return () => {
    window.removeEventListener('load', schedule)
    if (timer !== undefined) clearTimeout(timer)
  }
}
